export default function initShippingCompanyStocks() {
    return {
        async showModalShippingCompanyStock(event, id) {
            // event.preventDefault();
            const url = `/api/stocks/shipping-company/${id}/show-data-modal`;
            
            // Use the global ERPHelpers function for loading modal content
            await ERPHelpers.loadModalContent('addEditModal', url);
        },
        
        resetStock(event, shippingCompanyId) {
            Swal.fire({
                title: "Are you sure ?",
                text: "You will reset stock of this shipping-company.",
                icon: "warning", // Changed from 'type' to 'icon' for newer SweetAlert2
                showCancelButton: true,
                confirmButtonText: "Yes, change it !",
                cancelButtonText: "No, cancel !",
                closeOnConfirm: false,
                closeOnCancel: false
            }).then((confirmed) => {
                if (confirmed.value == true) {
                    axios.post(`/api/stocks/shipping-company/${shippingCompanyId}/reset-stock`, {})
                        .then(function (response) {
                            showSwal('successful-opperation', response.data.message);
                        }, error => {
                            showSwal('something-wrong', '');
                        });
                } else if (confirmed.dismiss == "cancel") { // Fixed typo: 'dissmiss' -> 'dismiss'
                    Swal.fire("Cancelled", "Status Unchanged !", "error");
                }
            });
        }
    }
}
